export enum ClampingTool {
  TriggerTorqueWrench15 = 'trigger_torque_wrench_15',
  ElectronicTorqueWrench10 = 'electronic_torque_wrench_10',
  PneumaticScrewdriver20 = 'pneumatic_screwdriver_20',
  ServoElectricScrewdriver10 = 'servo_electric_screwdriver_10',
  ServoControlledAutomaticElectricScrewdriver5 = 'servo_controlled_automatic_electric_screwdriver_5',
}
